<template>
  <el-dialog :title="title" custom-class="add-invoce-class" width="500px" :close-on-click-modal="false" :visible.sync="visible">
    <el-form ref="form" size="small" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="发票类目" prop="invoiceClassName">
        <el-input placeholder="请输入发票类目，例如，研发和技术服务" v-model="form.invoiceClassName"></el-input>
      </el-form-item>
      <el-form-item label="服务事项" prop="serviceItemId">
        <el-select placeholder="请选择服务事项，例如技术服务" v-model="form.serviceItemId">
          <el-option v-for="(item, index) in serviceList" :key="index" :label="item.serviceItemName" :value="item.serviceItemId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="add-tip">
      温馨提示：
      <span>1、若发票类目不存在，请先联系运营人员添加后再新增</span>
      <span>2、一个发票类目可能对应多个服务事项，请先核对贵司可受理的服务事项</span>
    </div>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'setAmount',
  props: {
    serviceList: Array,
  },
  data() {
    return {
      visible: false,
      edit: false, // 当前是否处于编辑状态
      editData: null,
      form: {
        invoiceClassName: '',
        serviceItemId: '',
      },
      rules: {
        invoiceClassName: [{ required: true, message: '请输入发票类目', trigger: 'blur' }],
        serviceItemId: [{ required: true, message: '请选择服务事项', trigger: 'change' }],
      },
    };
  },
  computed: {
    title() {
      return this.edit ? '发票类目编辑' : '新增发票类目';
    },
  },
  methods: {
    show(data) {
      this.edit = !!data;
      if (data) {
        this.editData = data;
        this.form.invoiceClassName = data.invoiceClassName;
        this.form.serviceItemId = data.serviceItemId;
      }
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = Object.assign({}, this.form);
          if (this.edit && this.editData) {
            data.invoiceClassId = this.editData.invoiceClassId;
            data.invoiceClassStatus = this.editData.invoiceClassStatus;
          }
          this.$emit('confirm', data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-invoce-class {
  .add-tip {
    margin-top: 24px;
    font-size: 14px;
    line-height: 22px;
    color: #ff9c00;
    > span {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/addInvoiceClass.vue